import t from '../../../text';
import { TrustPilotReviews } from './TrustPilotReviews';

export const BookingHeaderNav = () => (
  <div
    className="d-flex w-100 justify-content-between align-items-center px-3 header-bar"
    style={{ height: '42px' }}
  >
    <p className="telephone">{t('header.cs.tel')}</p>

    <TrustPilotReviews />
  </div>
);
